const clinic = {
  name: 'NutriAxis Nutrition Consultancy & Wellness Clinic',
  city: 'Thika, Kenya',
  phone: '+254 117 478271',
  email: 'info.nutriaxis@gmail.com',
  pin: 'P052431364W',
  tagline: 'Nutrition. Balance. Wellness.'
};

const formatMoney = (value) => Number(value || 0).toLocaleString();

const getItemName = (item) => item.product_name || item.service_name || item.name || 'Item';

const getReceiptItems = (items = []) => items.map((item) => {
  const quantity = Number(item.quantity || 1);
  const total = Number(item.total_price || 0);
  const unitPrice = Number(item.unit_price || (quantity ? total / quantity : total));

  return `
    <tr>
      <td>${getItemName(item)}</td>
      <td>${quantity}</td>
      <td>KES ${formatMoney(unitPrice)}</td>
      <td>KES ${formatMoney(total)}</td>
    </tr>
  `;
}).join('');

export const buildReceiptHtml = (saleData) => {
  const receiptNumber = saleData.receipt_number || 'N/A';
  const saleDate = new Date(saleData.sale_date || Date.now());
  const clientName = saleData.client_name || saleData.customer_name || 'Walk-in Customer';
  const total = Number(saleData.total_amount || 0);
  const discount = Number(saleData.discount || 0);
  const subtotal = Number(saleData.subtotal || total);
  const tax = Number(saleData.tax || 0);

  // Partial/remaining info (optional; may not exist on older receipts)
  const isPartial =
    Boolean(saleData.is_partial_sale) ||
    String(saleData.payment_status || '').toLowerCase().includes('partial') ||
    saleData.remaining_amount !== undefined ||
    saleData.balance_due > 0;

  const remainingAmount = Number(saleData.remaining_amount ?? saleData.balance_due ?? 0);
  const mpesaCode = saleData.mpesa_confirmation_code || null;

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Receipt - ${receiptNumber}</title>
        <style>
          * { box-sizing: border-box; }
          body {
            margin: 0;
            background: #f3f6f1;
            color: #111827;
            font-family: Arial, Helvetica, sans-serif;
          }
          .receipt-page {
            width: 210mm;
            min-height: 297mm; /* printable area */
            margin: 0 auto;
            padding: 8mm 10mm;
            background: #fff;
            page-break-after: avoid;
          }
          .receipt-card {
            position: relative;
            min-height: 277mm; /* printable card area */

            border: 2px solid #0f6b2f;
            border-radius: 8px;
            padding: 10mm;
            overflow: hidden;
          }
          .receipt-card::before {
            content: "";
            position: absolute;
            left: -24mm;
            bottom: 10mm;
            width: 70mm;
            height: 70mm;
            background: rgba(15, 107, 47, 0.12);
            border-radius: 60% 20% 60% 20%;
            transform: rotate(-24deg);
          }
          .brand {
            position: relative;
            text-align: center;
            margin-bottom: 9mm;
          }
          .brand img {
            width: 48mm;
            height: auto;
            display: block;
            margin: 0 auto 3mm;
          }
          .clinic {
            font-size: 11px;
            line-height: 1.45;
          }
          .title {
            width: 76mm;
            margin: 8mm auto 7mm;
            padding: 2mm 5mm;
            border-radius: 5px;
            background: linear-gradient(180deg, #17833a, #0d5527);
            color: white;
            font-size: 18px;
            font-weight: 800;
            letter-spacing: 1px;
            text-align: center;
          }
          .meta {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8mm;
            margin-bottom: 7mm;
            font-size: 12px;
          }
          .meta-right {
            border-left: 1px dashed #6b7280;
            padding-left: 8mm;
          }
          .row {
            display: grid;
            grid-template-columns: 26mm 1fr;
            gap: 3mm;
            margin-bottom: 2mm;
          }
          .label { font-weight: 700; }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }
          th {
            background: #f3f4f6;
            border-bottom: 1px solid #d1d5db;
            padding: 3mm 2mm;
            text-align: left;
          }
          td {
            border-bottom: 1px solid #e5e7eb;
            padding: 3mm 2mm;
          }
          th:nth-child(n+2), td:nth-child(n+2) { text-align: right; }
          .totals {
            width: 76mm;
            margin-left: auto;
            margin-top: 6mm;
            border-top: 1px dashed #6b7280;
            border-bottom: 1px dashed #6b7280;
            padding: 4mm 0;
            font-size: 12px;
          }
          .total-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 2mm;
          }
          .grand {
            margin-top: 3mm;
            font-size: 14px;
            font-weight: 800;
          }
          .payment {
            width: 82mm;
            margin: 8mm auto 0;
            border: 1px solid #0f6b2f;
            border-radius: 6px;
            padding: 4mm;
            font-size: 12px;
          }
          .thanks {
            position: relative;
            margin-top: 18mm;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            line-height: 1.45;
          }
          /* Ensure it stays on a single print page */
          @page { size: A4; margin: 0; }
          html, body { height: 100%; }

          @media print {
            body { background: #fff; margin: 0; }

            /* Force a single fixed-height document */
            .receipt-page {
              margin: 0 !important;
              padding: 10mm !important;
              box-shadow: none !important;
              height: 297mm !important;
              max-height: 297mm !important;
              overflow: hidden !important;
              page-break-after: avoid !important;
            }

            .receipt-card {
              max-height: 277mm !important;
              overflow: hidden !important;
              page-break-after: avoid !important;
            }

            /* Prevent splitting across pages where possible */
          .receipt-card, table, tr, td, th, section, footer { page-break-inside: avoid; }


            /* Compress content to guarantee fit on a single page */
            .receipt-page {
              transform: scale(0.90) !important;
              transform-origin: top left !important;
            }


            /* Compress typography to guarantee fit */
            table { font-size: 10px !important; }
            td, th { padding: 2mm 1.5mm !important; }

            .totals { margin-top: 4mm !important; padding: 3mm 0 !important; }
            .payment { margin: 6mm auto 0 !important; padding: 3.5mm !important; }
            .thanks { margin-top: 8mm !important; font-size: 12px !important; line-height: 1.35 !important; }

            /* Also shrink overall spacing */
            .meta { margin-bottom: 5mm !important; }
            .row { margin-bottom: 1.5mm !important; }
            .brand { margin-bottom: 7mm !important; }
            .title { margin: 6mm auto 5mm !important; }

          }
        </style>
      </head>
      <body>
        <main class="receipt-page">
          <section class="receipt-card" style="transform: none;">

            <header class="brand">
              <img src="/nutriaxis-logo.png" alt="NutriAxis" />
              <div class="clinic">
                <strong>${clinic.name}</strong><br />
                ${clinic.city}<br />
                ${clinic.phone} | ${clinic.email}<br />
                PIN: ${clinic.pin}
              </div>
            </header>

            <div class="title">RECEIPT / INVOICE</div>

            <section class="meta">
              <div>
                <div class="row"><span class="label">Receipt No:</span><span>${receiptNumber}</span></div>
                <div class="row"><span class="label">Date:</span><span>${saleDate.toLocaleDateString()}</span></div>
                <div class="row"><span class="label">Time:</span><span>${saleDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></div>
                <div class="row"><span class="label">Served by:</span><span>${saleData.cashier_name || 'Staff'}</span></div>
              </div>
              <div class="meta-right">
                <div class="row"><span class="label">Bill To:</span><span>${clientName}</span></div>
              </div>
            </section>

            <table>
              <thead>
                <tr>
                  <th>Item Description</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                ${getReceiptItems(saleData.items)}
              </tbody>
            </table>

            <section class="totals">
              <div class="total-line"><span>Subtotal</span><span>KES ${formatMoney(subtotal)}</span></div>
              <div class="total-line"><span>Discount</span><span>KES ${formatMoney(discount)}</span></div>
              <div class="total-line"><span>Tax</span><span>KES ${formatMoney(tax)}</span></div>
              <div class="total-line grand"><span>TOTAL</span><span>KES ${formatMoney(total)}</span></div>
            </section>

            <section class="payment">
              <div class="total-line"><strong>Payment Method:</strong><strong>${(saleData.payment_method || 'N/A').toUpperCase()}</strong></div>
              ${mpesaCode ? `<div class="total-line"><strong>M-Pesa Code:</strong><strong>${mpesaCode}</strong></div>` : ''}
              <div class="total-line"><strong>Amount Paid:</strong><strong>KES ${formatMoney(saleData.amount_paid || total)}</strong></div>

              ${isPartial ? `
                <div class="total-line"><strong>Status:</strong><strong style="color:#b91c1c">PARTIAL PAYMENT</strong></div>
                <div class="total-line"><strong>Total Amount:</strong><strong>KES ${formatMoney(total)}</strong></div>
                <div class="total-line"><strong>Remaining Balance:</strong><strong style="color:#b91c1c">KES ${formatMoney(remainingAmount)}</strong></div>
              ` : `
                <div class="total-line"><strong>Status:</strong><strong style="color:#15803d">PAID IN FULL</strong></div>
              `}

              <div class="total-line"><strong>Change:</strong><strong>KES 0</strong></div>
            </section>


            <footer class="thanks">
              Thank you for choosing NutriAxis!<br />
              ${clinic.tagline}
            </footer>
          </section>
        </main>
      </body>
    </html>
  `;
};
